// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalendarSection_wrapper__rTcGp"};